import { providerList } from '@blax-modules/base-front-end/resources/js/utilities/providers';
import { BindMessage } from "@blax-modules/base-front-end/resources/js/ui/message";
import { AlertColor } from "./parts/alert-color";

providerList.instantiate('BindMessageAlert', BindMessage, 'alert');
providerList.instantiate('BindAlertColor', AlertColor, 'alertColor');
